import { Button, Circle, Float, Menu, Portal } from '@chakra-ui/react';
import { UseNavigateResult } from '@tanstack/react-router';
import { t } from 'i18next';
import { FaLayerGroup } from 'react-icons/fa';

import { Tooltip } from '@/components/ui/tooltip';
import useMediaQuery from '@/hooks/use-media-query';

export const TableGroupMenu = ({
  groupBy,
  columnsDef,
  navigate,
}: {
  groupBy: string;
  columnsDef: Array<Record<string, any>>;
  navigate: UseNavigateResult<''>;
}) => {
  const isTooltipHidden = useMediaQuery('(min-width: 1250px)');

  return (
    <Menu.Root>
      <Menu.Trigger as="div">
        <Tooltip
          showArrow
          content={t('ui.group_by')}
          openDelay={100}
          closeDelay={100}
          contentProps={{ css: { '--tooltip-bg': 'colors.primary' } }}
          disabled={isTooltipHidden}
        >
          <Button variant="outline" size="sm" {...(!isTooltipHidden && { p: '0' })}>
            <FaLayerGroup />
            {isTooltipHidden && <span>{t('ui.group_by')}</span>}
            {groupBy && (
              <Float offsetY="1">
                <Circle size="5" bg="primary" color="white" fontSize={'xs'}>
                  1
                </Circle>
              </Float>
            )}
          </Button>
        </Tooltip>
      </Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content>
            <Menu.ItemGroup title={t('ui.group_by')} />
            <Menu.RadioItemGroup
              value={groupBy}
              onValueChange={(e) => {
                let new_group_by: string | null = null;
                if (e.value === groupBy) new_group_by = null;
                else new_group_by = e.value;
                navigate({
                  search: (prev: Record<string, string>) => ({
                    ...prev,
                    group_by: new_group_by,
                  }),
                });
              }}
            >
              {columnsDef.map(({ header, accessorKey, options }) => (
                <Menu.RadioItem key={accessorKey} value={accessorKey} disabled={!options?.enableGrouping === true}>
                  {typeof header === 'function' ? header() : header}
                  <Menu.ItemIndicator />
                </Menu.RadioItem>
              ))}
            </Menu.RadioItemGroup>
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};
